export default (value) => {
  return value || value === 0 ? value : '-'
}



// WEBPACK FOOTER //
// ./src/filters/numberFilter.js